export default __webpack_public_path__ + "static/media/mail.26a7c923.svg";